import Router from 'vue-router';
import Components from '@/views/Components.vue';
import CurrentTariff from '@/views/CurrentTariff.vue';
import QuoteResults from '@/views/QuoteResults.vue';
import TariffDetails from '@/views/TariffDetails.vue';
import PersonalDetails from '@/views/PersonalDetails.vue';
import SwitchComplete from '@/views/SwitchComplete.vue';
import CarbonOffsetExisting from '@/views/CarbonOffsetExisting.vue';
import CarbonOffset from '@/views/CarbonOffset.vue';
import CarbonOffsetProcess from '@/views/CarbonOffsetProcess.vue';
import ErrorPage from '@/views/ErrorPage.vue';

const router = new Router({
  routes: [
    // {
    //   path: '/components',
    //   name: 'components',
    //   component: Components
    // },
    {
      path: '/',
      redirect: '/results/home-energy'
    },
    {
      path: '*',
      redirect: '/error/404'
    },
    {
      path: '/home-energy/:customerId',
      name: 'currentTariffCustomer',
      component: CurrentTariff
    },
    {
      path: '/results/home-energy',
      name: 'quoteResults',
      component: QuoteResults
    },
    {
      path: '/tariff-details/:tariffId',
      name: 'tariffDetails',
      component: TariffDetails
    },
    {
      path: '/details',
      name: 'personalDetails',
      component: PersonalDetails
    },
    {
      path: '/switch-complete',
      name: 'switchComplete',
      component: SwitchComplete
    },
    {
      path: '/carbon-offset/:customerId',
      props: true,
      name: 'carbonOffset',
      component: CarbonOffset
    },
    {
      path: '/carbon-offset-process/:id?:oid?:c?',
      props: true,
      name: 'carbonOffsetProcess',
      component: CarbonOffsetProcess
    },
    // {
    //   path: '/carbon-offset-existing',
    //   name: 'carbonOffsetExisting',
    //   component: CarbonOffsetExisting
    // },
    {
      path: '/error/:status',
      name: 'error',
      component: ErrorPage
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
